// extracted by mini-css-extract-plugin
export default {"root":"PropertyAttachments_root__E2e4u","files-section":"PropertyAttachments_files-section__DBVj8"};